let authenticatedUser!: AuthenticatedUser | null;

export function setCurrentAuthenticatedUser(user: AuthenticatedUser): void {
  authenticatedUser = user;
}

export function getCurrentAuthenticatedUser(): AuthenticatedUser {
  return authenticatedUser!;
}

export function clearAuthenticatedUser(): void {
  authenticatedUser = null;
}

export interface AuthenticatedUser {
  id: string;
  email: string;
  familyName: string;
  name: string;
}
